export default __webpack_public_path__ + "ded2d42e6e97ea11296407a42d2d135c.webp";